import { el } from '../core/dom.js';

/** @param {number} [lines] */
export function skeleton(lines) {
  const count = lines || 3;
  const bars = [];
  for (let i = 0; i < count; i += 1) {
    bars.push(el('span', { class: i === count - 1 ? 'skel skel-short' : 'skel' }));
  }
  return el('div', { class: 'skeleton', role: 'status', 'aria-label': 'Loading' }, bars);
}
